module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo10-012efbd4c963e4a965efee83d530600b.jpg";